import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import safeGetPathname from './safeGetPathname';
import stripPathWithAsterisk from './stripPathWithAsterisk';
import envConfig from '../envs/envConfig';

const isRemoteRoute = (pathname: string) => {
  const { remoteRoutes } = envConfig;

  return Boolean(
    remoteRoutes?.find((route) =>
      pathname.startsWith(stripPathWithAsterisk(route.path))
    )
  );
};

const isRootRoute = (pathname: string) => {
  return pathname === '/';
};

const isExoRoute = (url: string) => {
  const pathname = safeGetPathname(url);
  const isRelativeRoute = pathname === url;
  const isInACC = isRelativeRoute || url.startsWith(getAccHostname());

  return isInACC && (isRemoteRoute(pathname) || isRootRoute(pathname));
};

export default isExoRoute;
